import SoftBox from 'components/SoftBox'
import SoftButton from 'components/SoftButton'
import SoftInput from 'components/SoftInput'
import SoftModal from 'components/SoftModal'
import SoftTypography from 'components/SoftTypography'
import { useUploadImage } from 'hook/services'
import React, { useState } from 'react'
import * as yup from 'yup'
import { useFormik } from 'formik'
import { useAgencyInfo } from "context/agency";
import Multiselect from './components/Multiselect'
// import { Slider } from '@mui/material'
import Slider from '@mui/material/Slider';
import MultistepFormWizard from "./MultistepFormWizard"
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  height: 500,
  bgcolor: 'background.paper',
  border: '2px  #000',
  boxShadow: 24,
  p: 4,
}

function EditsaasModal({ open, onClose,data, handleRefresh }) {


  return (
    <SoftBox>
      <SoftModal
        open={open}
        onClose={onClose}
        height={400}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <SoftBox sx={style}>
          <MultistepFormWizard data={data} onClose={onClose} handleRefresh={handleRefresh} />
        </SoftBox>
      </SoftModal>
    </SoftBox>
  )
}

export default EditsaasModal
